import * as React from "react";
const SvgFiRrCircleQ = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-q_svg__a)">
      <path
        fill="#062147"
        d="M12.038.02c-6.617 0-12 5.382-12 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12m0 22c-5.514 0-10-4.486-10-10s4.486-10 10-10 10 4.486 10 10-4.486 10-10 10m0-16.25c-2.757 0-5 2.243-5 5v2.5c0 2.756 2.243 5 5 5a4.98 4.98 0 0 0 2.904-.933l.39.39a.997.997 0 0 0 1.413 0 1 1 0 0 0 0-1.415l-.44-.44c.465-.758.733-1.65.733-2.602v-2.5c0-2.757-2.243-5-5-5m1.707 7.543a.999.999 0 1 0-1.414 1.413l1.164 1.164a3 3 0 0 1-1.457.38c-1.654 0-3-1.346-3-3v-2.5c0-1.654 1.346-3 3-3s3 1.346 3 3v2.5c0 .395-.078.773-.217 1.119z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-q_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleQ;
